export const palette = {
  daikinBlue: "#0085C5",
  hightlightGrey: "#5E6366",
  white: "#ffffff",
  navyBlue: "#11142d",
  greyFive: "#ABAFB1",
};
